import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {NewJobPostingDialog} from '../NewJobPostingDialog/NewJobPostingDialog';

import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';
import {CompanyLocation, JobPosting} from '../../../types/JobPostingsTypes';
import {JobPostingForm} from '../../forms/JobPostingForm/JobPostingForm';

interface NewJobPostingProps {
  companyId: string;
  companyLocations: CompanyLocation[];
  afterSubmit(newJobPosting: JobPosting): void;
  handleUpdateJobPosting(jobPosting: JobPosting): void;
}

export const NewJobPosting = ({
  companyId,
  companyLocations,
  afterSubmit,
  handleUpdateJobPosting,
}: NewJobPostingProps) => {
  const {t} = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = (_event?: React.MouseEvent, reason?: string) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }

    setIsModalOpen(!isModalOpen);
  };

  const handleFormCancel = () => {
    toggleModal();
  };

  return (
    <>
      <EmpionButton onClick={toggleModal}>{t('companyJobPostings.formButtons.new')}</EmpionButton>
      <NewJobPostingDialog open={isModalOpen} onClose={toggleModal}>
        <JobPostingForm
          companyId={companyId}
          companyLocations={companyLocations}
          onCancel={handleFormCancel}
          afterSubmit={afterSubmit}
          handleUpdateJobPosting={handleUpdateJobPosting}
        />
      </NewJobPostingDialog>
    </>
  );
};
